import ky from 'ky';

export const Mc3Client = ky.create({
  prefixUrl: '/api/mc3',
  credentials: 'include',
  timeout: 1000 * 30,
  retry: 0,
});
